<template>
  <v-form v-model="valid" ref="form">
    <v-dialog overlay-opacity="0.7" v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete_family')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" @click="deleteComponent(detail)" :loading="loading">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="pt-3 container">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col md="12">
              <v-card-title>
                <span class="headline">{{$t('family_list')}}</span>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :loading="loading"
                  :headers="headers"
                  :items="familyList"
                  :hide-default-footer="true"
                  :no-data-text="$t('no_data')"
                >
                  <template v-slot:item.no="{index}">{{index+1}}</template>
                  <template v-slot:item.dependent="{item}">{{item.dependent == 1? $t('yes') : $t('no')}}</template>
                  <template v-slot:item.action="{item}">
                    <v-btn plain class="primary--text" @click="seeDetail(item)">{{$t('see_details')}}</v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-col>
            <v-col md="12" class="pt-0">
              <div class="sae-grey" @click="add">
                <v-icon class="ml-2">mdi-plus</v-icon>
                <span class="ml-4">{{$t('family_member')}}</span>
              </div>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item>
          <v-row>
            <v-col md="6">
              <v-btn icon @click="tab = 0">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>{{$t('back')}}
            </v-col>
            <v-col md="6" class="text-right" v-if="isEdit">
              <v-btn icon @click="deleteItem(detail)" color="error">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-row align="center">
                <v-divider></v-divider>
                <v-btn plain disabled>{{$t('family_data')}}</v-btn>
                <v-divider></v-divider>
              </v-row>
            </v-col>
            <v-col md="12">
              <v-select
                :label="$t('relation')"
                v-model="detail.relationId"
                :items="relationList"
                item-text="nameId"
                item-value="id"
                :rules="rules2"
                required
                class="sae-required"
              ></v-select>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('name')"
                v-model="detail.name"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="12">
              <v-textarea
               :label="$t('address')"
                v-model="detail.address"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                auto-grow
                rows="1"
                required
                class="sae-required"
              ></v-textarea>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('phoneNumber')"
                v-model="detail.phoneNumber"
                type="number"
                :rules="[...rules4, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="6">
              <v-text-field
                :label="$t('placeOfBirth')"
                v-model="detail.placeOfBirth"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="6">
              <v-menu
                ref="menu"
                v-model="menuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateFormatted(detail.dateOfBirth)"
                    :label="$t('dateOfBirth')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    color="primary"
                    :rules="rules"
                    required
                    class="sae-required"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="detail.dateOfBirth"
                  @change="onStartDateChange"
                  no-title
                  scrollable
                  :locale="$t('locale')"
                  :max="maxDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="12">
              <v-select
                :label="$t('gender')"
                v-model="detail.genderId"
                :rules="rules2"
                :items="genderList"
                item-text="nameId"
                item-value="id"
                required
                class="sae-required"
              ></v-select>
            </v-col>
            <v-col md="12">
              <v-select
                :label="$t('dependent')"
                v-model="detail.dependent"
                :items="dependentList"
                item-text="nameId"
                item-value="id"
                :rules="rules2"
                required
                class="sae-required"
              ></v-select>
            </v-col>

            <v-col cols="12" v-if="detail.attachments">
              <v-row align="center">
                <v-divider></v-divider>
                <v-btn plain disabled>{{$t('documents')}}</v-btn>
                <v-divider></v-divider>
              </v-row>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn @click="addAttachment">
                <v-icon>mdi-plus</v-icon>{{$t('document')}}
              </v-btn>
            </v-col>
            <v-col md="12" v-for="(item,i) in detail.attachments" v-bind:key="i">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    :label="`${$t('document_name')} ${i+1}`"
                    v-model="item.attachmentName"
                    :rules="[...rules, validator.alfaNumberNotRequired]"
                    required
                    class="sae-required"
                  ></v-text-field>
                </v-col>
                <v-col class="text-left">
                  <v-btn
                    class="mt-4"
                    block
                    outlined
                    v-if="isEdit && item.attachmentUrl"
                    :href="item.attachmentUrl"
                    target="_blank"
                  >
                    <v-icon color="primary">{{getExtension(item.attachment)}}</v-icon>
                    &nbsp;{{`${$t('document')} ${i+1}`}}
                    <div class="flex-grow-1"></div>
                  </v-btn>
                  <v-file-input
                    :label="`${$t('document')} ${i+1}`"
                    accept="image/*, application/pdf"
                    v-model="item.file"
                    @change="uploadImage(item.file, item)"
                    :rules="item.attachmentUrl ? [] : rules"
                    required
                    class="sae-required"
                  ></v-file-input>
                  <v-progress-linear v-show="item.loading" :value="item.progress"></v-progress-linear>
                </v-col>
                <v-col cols="1">
                  <v-btn icon color="error" class="mt-4" @click="deleteAttachment(i, item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="12" class="text-center">
              <v-btn plain class="ma-2 primary--text" @click="reload();tab = 0;isEdit=false;">{{$t('cancel')}}</v-btn>
              <v-btn
                color="primary"
                class="ma-2"
                :loading="loading"
                :disabled="!valid"
                @click="saveOrUpdate(detail)"
              >{{$t('save')}}</v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-form>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import ENV from './../../../../store/modules/environtment'

export default {
  props: ['userId', 'familyList'],
  name: "Family-List",
  data() {
    return {
      headers: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('name'), value: "name" },
        { text: this.$i18n.t('relationship'), value: "relation" },
        { text: this.$i18n.t('dependent'), value: "dependent" },
        { text: "", value: "action" },
      ],
      tab: 0,
      rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
      rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules3: [
        v => (v && v.length == 4) || this.$i18n.t('year_required'),
        v => /^[0-9]+$/.test(v) || this.$i18n.t('number_required'),
        v => (v && v >= parseInt(moment(this.detail.startDate).locale(this.$i18n.t('lang')).format('YYYY'))) || `Please input above ${parseInt(moment(this.detail.startDate).format('YYYY'))}`,
        v => (v && v <= parseInt(moment(this.detail.startDate).locale(this.$i18n.t('lang')).format('YYYY')) + 10) || `Please input below ${parseInt(moment(this.detail.startDate).format('YYYY')) + 10}`,
      ],
      rules4: [
        v => /^[0-9.,]+$/.test(v) || this.$i18n.t('number_required'),
        (value) => (value === 0 ? true : !!value || this.$i18n.t('required'))
      ],
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      valid: false,
      formData: [],
      userIdLogin: this.$store.getters.user.id,
      loading: false,
      detail: {},
      isEdit: false,
      deleteDialog: false,
      relationList: [
        { id: 1, nameId: 'Suami' },
        { id: 2, nameId: 'Istri' },
        { id: 3, nameId: 'Ayah' },
        { id: 4, nameId: 'Ibu' },
        { id: 5, nameId: 'Anak Pertama' },
        { id: 6, nameId: 'Anak Kedua' },
        { id: 7, nameId: 'Anak Keempat' },
        { id: 8, nameId: 'Anak Kelima' },
      ],
      genderList: [
        { id: 1, nameId: 'Laki-laki' },
        { id: 2, nameId: 'Perempuan' },
        { id: 3, nameId: 'Lainnya' },
      ],
      dependentList: [
        { id: 1, nameId: this.$i18n.t('yes') },
        { id: 0, nameId: this.$i18n.t('not') },
      ],
      menuStart: false,
      maxDate: moment().locale(this.$i18n.t('lang')).subtract(1, 'day').format('YYYY-MM-DD')
    }
  },
  methods: {
    async deleteAttachment(i, item) {
      this.detail.attachments.splice(i, 1)
      if (item.id) {
        await this.$store.dispatch('deleteFamilyAttachment', item)
      }
    },
    seeDetail(item) {
      this.isEdit = true
      this.detail = Object.assign({ attachments: [] }, item)
      this.detail.dateOfBirth = moment(this.detail.dateOfBirth).locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
      this.tab = 1
    },
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    addAttachment() {
      this.detail.attachments.push({
        attachmentName: '',
        attachmentPrefix: '',
        attachment: '',
        progress: 0,
        loading: false,
      })
    },
    add() {
      this.isEdit = false
      this.detail = { userId: this.userId, dateOfBirth: null, attachments: [] }
      this.tab = 1
    },
    formatTime(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY")
    },
    dateFormatted(date) {
      if (date) return moment(date).locale(this.$i18n.t('lang')).format('Do MMMM YYYY');
      return null
    },
    onStartDateChange() {
      this.menuStart = false;
    },
    async getRelation() {
      this.loading = true
      this.relationList = await this.$store.dispatch('getRelations')
      this.loading = false
    },
    async getGender() {
      this.loading = true
      this.genderList = await this.$store.dispatch('getGender')
      this.loading = false
    },
    getExtension(attachment = '') {
      const ext = attachment.split('.')
      switch (ext[ext.length - 1]) {
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
          return 'mdi-file-image-outline'

        default:
          return 'mdi-attachment'
      }
    },
    getParentData() {
      this.formData = this.familyList
    },
    async uploadImage(image, item) {
      if (!image) return null
      const companyId = this.$store.state.company
      const prefix = `${ENV.firebase.prifixEmployee}${companyId}/${this.userId}/master_employee/family`
      const url = `${this.baseUrl}/download/file_upload_general`
      const headers = { headers: { 'Content-Type': 'multipart/form-data', action: 'File Upload', actionId: 1 } }
      try {
        const formData = new FormData();
        formData.append('file', image)
        formData.append('path', `${prefix}`)
        item.loading = true
        const result = await axios.post(url, formData, {
          ...headers,
          onUploadProgress: (e) => {
            item.progress = Math.round(e.loaded / e.total * 100)
          }
        })
        item.loading = false
        if (result) {
          if (result.data.code == 200) {
            item.attachmentPrefix = result.data.data.path
            item.attachment = result.data.data.fileName
            return result.data.data
          }
        }
        return { url: 'img/default-image.png' }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message)
        item.loading = false
        return { url: 'img/default-image.png' }
      }
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = { ...data }
      this.loading = true
      const result = await this.$store.dispatch('saveFamily', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    async editComponent(data) {
      const body = { ...data, userId: this.userId }
      this.loading = true
      const result = await this.$store.dispatch('editFamily', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    deleteItem() {
      this.deleteDialog = true;
    },
    async deleteComponent(data) {
      const body = { ...data, addressType: data.type }
      this.loading = true
      const result = await this.$store.dispatch('deleteFamily', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_delete'))
        this.$emit('reload', true)
        this.tab = 0
        this.deleteDialog = false
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    refreshData() {
      if (this.familyList) {
        this.formData = this.familyList
      } else {
        this.formData = []
        this.detail = { dateOfBirth: null, attachments: [] }
      }
    },
    reload() {
      this.$emit('reload', true)
    }
  },
  created() {
    this.getParentData()
    this.getRelation()
    this.getGender()
  },
  watch: {
    familyList() {
      this.formData = this.familyList
      this.tab = 0
      this.detail = { attachments: [], dateOfBirth: null }
    },
    userId() {
      this.refreshData()
    },
    tab(tab) {
      if (this.$refs.form && !this.isEdit && tab == 1) {
        this.$refs.form.reset();
      }
    },
  }
}
</script>
<style scoped>
.camelcase {
  text-transform: capitalize !important;
}
.sae-grey {
  background: #7c8a963d;
  line-height: 35px;
  cursor: pointer;
}
</style>